<template>
  <v-dialog :value="value" persistent max-width="800px">
    <div class="modal-container">
      <div class="d-flex w-full justify-end">
        <v-btn icon @click="$emit('input', false)" class="-mt-12 -mr-12">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <img loading="lazy" src="https://storage.googleapis.com/keybe/files/bluebird/billing/celebration.svg"
           alt="credit card" class="mb-8">
      <strong>¡Ahora eres Pro!</strong>
      <span>Bienvenido al plan Pro de Keybe, disfruta  de todos los beneficios desde ahora.</span>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'FisishUpgradeDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  padding: 4rem
}
</style>
